import clsx from "clsx";

const TestingEnvLabel = ({ src = "/images/login-logo.svg", classes = "" }) => {
  return (
    <div className="logo-container">
      <img src={src} alt="Company Logo" className={clsx("logo", classes)} />
      {process.env.REACT_APP_NODE_ENV === "development" ? (
        <span className={`logo-label top-right`}>Test</span>
      ) : (
        ""
      )}
    </div>
  );
};

export default TestingEnvLabel;
